import { Component, OnInit } from '@angular/core';
import { BonusqrService } from 'src/app/shared/servicio/bonusqr/bonusqr.service';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';

@Component({
  selector: 'app-bonus-qr-summary',
  templateUrl: './bonus-qr-summary.component.html',
  styleUrls: ['./bonus-qr-summary.component.css'],
})
export class BonusQrSummaryComponent implements OnInit {
  loading = true;
  summary: any;

  constructor(private _bonusqr: BonusqrService, public _helper: HelpersService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this._bonusqr.getSummary().subscribe(
      (data: any) => {
        this.summary = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
        this._helper.modalError('No se pudo cargar el resumen');
      }
    );
  }

  get totalCount(): number {
    if (!this.summary) {
      return 0;
    }
    return (this.summary.active_count || 0) + (this.summary.inactive_count || 0);
  }
}
